var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('div',[(_vm.isList)?_c('location-list',{ref:"table",attrs:{"title":""}}):_c('location-view',{ref:"locationView",attrs:{"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }